import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cld } from "@/lib/api";

const ORIGINAL_LABELS = ["The painting", "Surface detail", "Signature", "In the room"];

export const ImageSlider = ({ images = [], title, isOriginal }) => {
  const [idx, setIdx] = useState(0);
  const n = images.length;

  useEffect(() => {
    setIdx(0);
  }, [images]);

  if (!n) return <div className="aspect-[4/5] bg-[#F2EEE6]" />;
  const go = (d) => setIdx((i) => (i + d + n) % n);
  const label = isOriginal && n === 4 ? ORIGINAL_LABELS[idx] : `View ${idx + 1} of ${n}`;

  return (
    <div data-testid="product-image-slider">
      <div className="group relative aspect-[4/5] overflow-hidden bg-[#F2EEE6]">
        <img key={images[idx]} src={cld(images[idx], "w_1400,q_auto,f_auto")} alt={`${title} — ${label}`} className="slow-fade h-full w-full object-cover" data-testid="product-main-image" />
        {n > 1 && (
          <>
            <button aria-label="Previous image" data-testid="product-image-prev" onClick={() => go(-1)} className="absolute left-4 top-1/2 -translate-y-1/2 bg-[#FDFBF7]/80 p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100 max-md:opacity-100">
              <ChevronLeft size={18} strokeWidth={1.25} />
            </button>
            <button aria-label="Next image" data-testid="product-image-next" onClick={() => go(1)} className="absolute right-4 top-1/2 -translate-y-1/2 bg-[#FDFBF7]/80 p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100 max-md:opacity-100">
              <ChevronRight size={18} strokeWidth={1.25} />
            </button>
          </>
        )}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <p className="eyebrow" data-testid="product-image-label">{label}</p>
        <p className="text-xs text-[#8A8780]">{String(idx + 1).padStart(2, "0")} / {String(n).padStart(2, "0")}</p>
      </div>
      {n > 1 && (
        <div className="mt-5 grid grid-cols-4 gap-3">
          {images.map((src, i) => (
            <button key={src + i} data-testid={`product-image-slider-thumb-${i}`} onClick={() => setIdx(i)} className={`aspect-[4/5] overflow-hidden transition-opacity duration-300 ${i === idx ? "opacity-100 ring-1 ring-[#1A1A1A] ring-offset-2 ring-offset-[#FDFBF7]" : "opacity-55 hover:opacity-100"}`}>
              <img src={cld(src, "w_240,q_auto,f_auto")} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
